import React from "react";
import ProfileImg from "./../../../assets/images/profileImage.jpg";
import "video-react/dist/video-react.css";
import { Player } from "video-react";
import Stack from "@mui/material/Stack";
import { AiOutlineClockCircle } from "react-icons/ai";
import Rating from "@mui/material/Rating";
import { SideMenu, BackHeader } from "./../../components";
import { useNavigate } from "react-router-dom";
import { GrFacebookOption, GrTwitter } from "react-icons/gr";
import { FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
const CourseHistoryView = () => {
  const navigate = useNavigate();
  return (
    <SideMenu>
      <div className="page-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <Player
          fluid={false}
          width={"100%"}
          height={406}
          className="play"
          playsInline
          poster={ProfileImg}
          src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
        />
        <div className="video-section-header-main">
          <p className="video-section-header-heading">
            Integer facilisis pulvinar molestie. Duis justo lectus
          </p>
          <div className="video-section-header-date-main">
            <AiOutlineClockCircle color="#303030" />
            <p className="video-section-header-date">JAN 31, 2022, 10:30 AM</p>
          </div>
        </div>
        <p className="video-description">
          Quisque a fringilla nisi, nec suscipit justo. Pellentesque habitant
          morbi tristique senectus et netus et malesuada fames ac turpis
          egestas. Fusce nulla odio, mattis vel nibh eget, suscipit laoreet
          libero.
        </p>
        <p className="video-section-user-heading">Tutor Name</p>
        <div className="data-view-cover-footer-container">
          <div
            className="video-section-user-profile-main"
            style={{ border: "none" }}
          >
            
            <img
              src={ProfileImg}
              className="video-section-user-profile-image"
            />
            <div>
              <p className="video-section-user-name">David anderson</p>
              <p className="video-section-user-location">burnside</p>
            </div>
          </div>
          <div className="share-main">
            <p className="data-view-cover-footer-data">share</p>
            <div>
              <button className="share-button">
                <GrFacebookOption color="white" size={20} />
              </button>
              <button className="share-button">
                <FaLinkedinIn color="white" size={20} />
              </button>
              <button className="share-button">
                <GrTwitter color="white" size={20} />
              </button>
              <button className="share-button">
                <FaWhatsapp color="white" size={20} />
              </button>
            </div>
          </div>
        </div>
        <p className="video-section-review-heading">Ratings & Reviews</p>
        <div className="box-rating-main">
          <div className="box-rating-header">
            <img src={ProfileImg} className="box-list-image" />

            <div className="box-rating-second-section">
              <div>
                <p className="box-rating-username">Johan smith</p>
                <p className="box-rating-time">5 Lectures, 45 min</p>
              </div>
              <div className="box-rating-show">
                <Stack spacing={1}>
                  <Rating
                    name="half-rating-read"
                    defaultValue={5}
                    precision={1}
                    readOnly
                  />
                </Stack>
                <p className="box-rating-day">Yesterday</p>
              </div>
            </div>
          </div>
          <p className="box-rating-message">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in lorem
            congue, euismod urna vitae, porttitor mi. Aliquam consectetur eu
            turpis ac congue.
          </p>
        </div>
        <div className="box-rating-main">
          <div className="box-rating-header">
            <img src={ProfileImg} className="box-list-image" />

            <div className="box-rating-second-section">
              <div>
                <p className="box-rating-username">Johan smith</p>
                <p className="box-rating-time">5 Lectures, 45 min</p>
              </div>
              <div className="box-rating-show">
                <Stack spacing={1}>
                  <Rating
                    name="half-rating-read"
                    defaultValue={4}
                    precision={1}
                    readOnly
                  />
                </Stack>
                <p className="box-rating-day">Yesterday</p>
              </div>
            </div>
          </div>
          <p className="box-rating-message">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in lorem
            congue, euismod urna vitae, porttitor mi. Aliquam consectetur eu
            turpis ac congue.
          </p>
        </div>
      </div>
    </SideMenu>
  );
};
export default CourseHistoryView;
